<script>
    import { mapActions } from "vuex";
    import http from "../../http";
    import logo from "../../assets/gota.svg";
    import FLoginForm from "./FLoginForm";
    import FLoginRequest from "./FLoginRequest";

    export default {
        components: {
            FLoginForm,
            FLoginRequest
        },

        data: () => ({
            logo
        }),

        methods: {
            ...mapActions(["signIn"]),

            async login(auth) {
                try {
                    const intent = this.$route.query.intent || "/";

                    await this.signIn(auth);

                    this.$router.push(intent);
                } catch (e) {
                    console.log(e);
                }
            }
        }
    };
</script>

<template>
    <section class='fluid__login'>
        <section class='fluid__login__container'>
            <header class='fluid__login__header'>
                <img :src='logo' class='fluid__footer__logo' alt='Logo do aplicativo Fluid'>
                <FLoginRequest/>
            </header>

            <FLoginForm @hasSubmit='login'/>
        </section>
    </section>
</template>

<style scoped>
    .fluid__login {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fluid__login__container {
        padding: 20px;
        width: 100%;
        max-width: 400px;
    }

    .fluid__login__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .fluid__footer__logo {
        height: 35px;
        object-fit: contain;
    }
</style>
